import script from "./HorizontalBar.vue?vue&type=script&lang=js"
export * from "./HorizontalBar.vue?vue&type=script&lang=js"

export default script